import React, { useEffect } from 'react';
import { Snackbar, Alert, Typography, Box } from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import { useGame } from '../context/GameProvider';
import { useViewport } from '../../../shared/hooks/useViewport';
import { PHONE_TOAST_SX } from '../../../shared/constants/layout';

const COMBO_DISPLAY_MS = 5000;

const ComboNotification: React.FC = () => {
  const { pendingCombo, clearCombo } = useGame();
  // At the top of a phone the toast covers the header, so it sits at the bottom there.
  const { isPhone } = useViewport();

  useEffect(() => {
    if (!pendingCombo) return;
    const timer = setTimeout(clearCombo, COMBO_DISPLAY_MS);
    return () => clearTimeout(timer);
  }, [pendingCombo, clearCombo]);

  if (!pendingCombo) return null;

  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: isPhone ? 'bottom' : 'top', horizontal: 'center' }}
      sx={isPhone ? PHONE_TOAST_SX : undefined}
      onClose={clearCombo}
    >
      <Alert
        severity="success"
        icon={<LocalFireDepartmentIcon />}
        onClose={clearCombo}
        sx={{ alignItems: 'center' }}
      >
        <Box>
          <Typography variant="subtitle2" fontWeight="bold">
            {pendingCombo.combo_name}!
          </Typography>
          <Typography variant="caption">
            +{pendingCombo.bonus_percentage}% bonus — {pendingCombo.points_earned} pts earned
          </Typography>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default ComboNotification;
